import { api } from "..";

export const clearLeaguesCache = async (): Promise<{ success: boolean }> => {
  const res = await api.client.post("/leagues-new/clear-cache");
  return res.data;
};
